var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-menu"},[_c('Item',{attrs:{"activeItem":_vm.value,"data":_vm.headerItem,"type":'status'},on:{"itemClick":_vm.handleItemClick}}),_vm._l((_vm.list),function(item,index){return [_c('Item',{key:index,attrs:{"activeItem":_vm.value,"data":item},on:{"itemClick":_vm.handleItemClick}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }